/** init domain config */
import './config'

import global_ from './components/page/Global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import { VueAxios } from '@/utils/request'
import { getAction, postFormAction, postAction } from '@/api/manage'

// require('@jeecg/antd-online-mini')
// require('@jeecg/antd-online-mini/dist/OnlineForm.css')
import Antd, { version } from 'ant-design-vue'
// console.log('ant-design-vue version:', version)
import 'ant-design-vue/dist/antd.less'  // or 'ant-design-vue/dist/antd.less'
import '@/permission' // permission control
import '@/utils/filter' // base filter
import Print from 'vue-print-nb-jeecg'
/*import '@babel/polyfill'*/
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import SSO from '@/cas/sso.js'
import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_PAGE
} from '@/store/mutation-types'
import config from '@/defaultSettings'
import JDictSelectTag from './components/dict/index.js'
import hasPermission from '@/utils/hasPermission'
import vueBus from '@/utils/vueBus'
import JeecgComponents from '@/components/jeecg/index'
import DynamicForm from '@/components/online/autoform/index';
import '@/assets/less/JAreaLinkage.less'
import VueAreaLinkage from 'vue-area-linkage'
import '@/components/jeecg/JVxeTable/install'
import '@/components/JVxeCells/install'
import VueI18n from 'vue-i18n'
import { toast,getLanguageEnable } from '@/utils/util'
import { langInput } from '@comp/mtcModule'
import '@assets/less/common.less';

Vue.prototype.$toast = toast
Vue.prototype.$langInput = langInput
Vue.prototype.$getLanguageEnable = getLanguageEnable
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(DynamicForm)
Vue.use(VueAxios, router)
Vue.use(hasPermission)
Vue.use(JDictSelectTag)
Vue.use(Print)
Vue.use(preview)
Vue.use(vueBus)
Vue.use(JeecgComponents)
Vue.use(VueAreaLinkage)

// 挂载全局使用的方法
Vue.prototype.doMian = '/'
Vue.prototype.postFormAction = postFormAction
Vue.prototype.postDataAction = postAction
Vue.prototype.getAction = getAction
Vue.prototype.$bus = new Vue()

/*系统参数 名称 等等*/
Vue.prototype.systemBase = {
  year: config.year,
  company: config.company,
  title: config.title,
  explain: ''
}

// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = new VueI18n({
  locale: Vue.ls.get('language', 'zh-cn'),
  // 是否取消本地化失败时输出的警告
  silentTranslationWarn: true,
  messages: {
    'zh-cn': require('@/assets/lang/zh-CN.js'),
    'en-us': require('@/assets/lang/en-US.js'),
    'vi-vn': require('@/assets/lang/vi-VN.js')
  }
})

SSO.init(() => {
  main()
})

function main(){
  new Vue({
    router,
    store,
    i18n,
    mounted(){
      store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
      store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
      store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
      store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
      store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
      store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
      store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
      store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
      store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
      store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
      store.commit('SET_MULTI_PAGE', Vue.ls.get(DEFAULT_MULTI_PAGE, config.multipage))
    },
    render: h => h(App)
  }).$mount('#app')
}